export const updateAtmObservationAssignments = (
  observationAssignments,
  observedExternalUserId,
  observerExternalUserId
) => {
  if (!observerExternalUserId) {
    return observationAssignments.filter(
      obs => obs.observedExternalUserId !== observedExternalUserId
    );
  }

  const updatedAssignments = observationAssignments.filter(
    obs =>
      obs.observedExternalUserId !== observedExternalUserId &&
      obs.observerExternalUserId !== observerExternalUserId
  );

  return [
    ...updatedAssignments,
    createNewObservationAssignment(observedExternalUserId, observerExternalUserId)
  ];
};

export const removeUserObservationAssignments = (observations, externalUserId) =>
  observations?.filter(obs => !isObservationByObserver(obs, externalUserId));

const createNewObservationAssignment = (observedExternalUserId, observerExternalUserId) => {
  return {
    observerExternalUserId,
    observedExternalUserId
  };
};

const isObservationByObserver = (observation, observerUserId) =>
  observation.observerExternalUserId === observerUserId ||
  observation.observedExternalUserId === observerUserId;
